import { Fragment } from 'react'
import { parseHtml } from '../../utils/common'
import { Col, Container, Row } from 'react-bootstrap'
import dynamic from "next/dynamic";

const HocHead = dynamic(() => import('../../components/HigherOrderComponent/HocHead'))

const TemplatePages = ({ data }) => {

	const { content = '', title, seo} = data.data[0].attributes

	const TemplatePage = () => (
		<Fragment>
			{parseHtml(content)}
		</Fragment>
	)

	return (
		<>
			{seo && <HocHead seo={seo} type={'template'}/>}
			<div className="middle-sction middle-pad">
				<div className="request-proposal request-proposal-form">
					<section className="request-banner-section">
						<div className="request-banner-inner">
							<Container>
								<Row>
									<Col lg={12}>
										<h1>{title}</h1>
										<hr />
										<TemplatePage />
									</Col>
								</Row>
							</Container>
						</div>
					</section>
				</div>
			</div>
		</>
	)
}

export default TemplatePages
